// this must be an object, for test purposes it's a function

var USE_MERCURE = function USE_MERCURE(locale) {
  var result = {
    'fr-FR': true,
    'nl-BE': true,
    'fr-BE': true,
    'de-DE': true,
    'es-ES': true,
    'it-IT': true,
    'fr-LU': true,
    'nl-NL': true,
    'de-AT': true,
    'pt-PT': false,
    'de-CH': false,
    'it-CH': false,
    'fr-CH': false,
    'en-GB': true
  };
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_FR')) {
    result['fr-FR'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_UK')) {
    result['en-GB'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_ES')) {
    result['es-ES'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_DE')) {
    result['de-DE'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_IT')) {
    result['it-IT'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_AT')) {
    result['de-AT'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_BE')) {
    result['fr-BE'] = false;
    result['nl-BE'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_NL')) {
    result['nl-NL'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE_LU')) {
    result['fr-LU'] = false;
  }
  if (process.client && localStorage.getItem('TOGGLE_MERCURE')) {
    result = {
      'fr-FR': true,
      'nl-BE': true,
      'fr-BE': true,
      'de-DE': true,
      'es-ES': true,
      'it-IT': true,
      'fr-LU': true,
      'nl-NL': true,
      'de-AT': true,
      'pt-PT': true,
      'de-CH': true,
      'it-CH': true,
      'fr-CH': true,
      'en-GB': true
    };
  }
  return result[locale];
};
export default USE_MERCURE;